<template>
  <b-modal
    ref="modal"
    title="Search Help"
    size="lg"
    no-fade
    ok-only
  >
      <div class="alert alert-info">
        SYNTAX: Search terms must be followed by a colon and use quotes for search terms containing spaces, dashes, etc.
      </div>

      <div class="card">
        <div class="card-body">
          <div class="card-title font-weight-bold">Searchable Fields</div>
          <div class="mb-3">
            <code>
              id, api, client, job_id, created_at, status
            </code>
          </div>

          <div class="card-title font-weight-bold">Example</div>
          <div class="row">
            <div class="col">
              <code>
                <p>id: 1e6d204c-f979-45c5-a3eb-da28f9f6d198</p>
                <p>api: plan_lay_cut_data</p>
                <p>client: crystal_martin</p>
                <p>job_id: ba3f9f4fd4fed514b9e8a756</p>
                <p>status: pending</p>
              </code>
            </div>
          </div>
        </div>
      </div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    show() {
      this.$refs.modal.show();
    }
  }
};
</script>

<style>
code {
  color: #212529;
}
</style>
